import * as logger from './logger-service';
import * as api from './api-client';

export const spirsApi = {
    logger,
    api
};
